/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import t from "../core/Logger.js";
import { getDeepValue as r } from "../core/object.js";
import { replace as e } from "../core/string.js";
import { formatDate as n } from "./date.js";
import { formatNumber as o } from "./number.js";
var i = t.getLogger("esri.intl");

function s(t, r) {
  var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var _n$format = n.format,
      o = _n$format === void 0 ? {} : _n$format;
  return e(t, function (t) {
    return u(t, r, o);
  });
}

function u(t, e, n) {
  var o, i;
  var s = t.indexOf(":");
  if (-1 === s ? o = t.trim() : (o = t.slice(0, s).trim(), i = t.slice(s + 1).trim()), !o) return "";
  var u = r(o, e);
  if (null == u) return "";
  var m = n[i] || n[o];
  return m ? c(u, m) : i ? a(u, i) : f(u);
}

function c(t, r) {
  switch (r.type) {
    case "date":
      return n(t, r.intlOptions);

    case "number":
      return o(t, r.intlOptions);

    default:
      return i.warn("missing format descriptor for key {key}"), f(t);
  }
}

function a(t, r) {
  switch (r.toLowerCase()) {
    case "dateformat":
      return n(t);

    case "numberformat":
      return o(t);

    default:
      return i.warn("inline format is unsupported since 4.12: ".concat(r)), /^(dateformat|datestring)/i.test(r) ? n(t) : /^numberformat/i.test(r) ? o(t) : f(t);
  }
}

function f(t) {
  switch (typeof t) {
    case "string":
      return t;

    case "number":
      return o(t);

    case "boolean":
      return "" + t;

    default:
      return t instanceof Date ? n(t) : "";
  }
}

export { s as substitute };